import React from "react";
import { useAuth } from "providers/AuthProvider";
import Tarifs from "./ParametreTabs/Tarifs";
import Utilisateurs from "./ParametreTabs/Utilisateurs";
import ImportPartenaires from "./ParametreTabs/ImportPartenaires";
import { UtilisateursDetails } from "./ParametreTabs/UtilisateursDetails";
import { Link, useParams, Navigate } from "react-router-dom";
import Main from "components/Main";
import Partenaires from "./ParametreTabs/Partenaires";
import BonusTerritorial from "./ParametreTabs/BonusTerritorial";

const Parametres = () => {
  const { isAdmin } = useAuth();
  const { tabID, userID } = useParams();
  const tabs = [
    { id: "tarifs", label: "Tarifs" },
    { id: "bonus", label: "Bonus territorial" },
    { id: "utilisateurs", label: "Utilisateurs" },
    { id: "import-partenaires", label: "Import partenaires" },
    { id: "partenaires", label: "Partenaires" },
  ];
  const currentID =
    tabID && tabs.find((tab) => tab.id === tabID) ? tabID : "utilisateurs";

  function SwitchTabs(title) {
    switch (title) {
      case "tarifs":
        return <Tarifs />;

      case "utilisateurs":
        return <Utilisateurs />;

      case "utilisateurs-details":
        return <UtilisateursDetails userID={+userID} />;

      case "bonus":
        return <BonusTerritorial />;

      case "import-partenaires":
        return isAdmin && <ImportPartenaires />;

      case "partenaires":
        return isAdmin && <Partenaires />;

      default:
        return <Tarifs />;
    }
  }

  if (isAdmin) {
    return (
      <Main title="Paramètres">
        <div className="border-b-2 pb-1 capitalize">
          {tabs.map((item) => (
            <Link to={`/parametres/${item.id}`} key={item.id}>
              <button
                className={
                  currentID === item.id
                    ? "inline mx-4 text-main-color font-medium underline underline-offset-10"
                    : "inline mx-4 font-medium text-[#9E9E9E]"
                }
              >
                {item.label}
              </button>
            </Link>
          ))}
        </div>

        {SwitchTabs(userID ? "utilisateurs-details" : currentID)}
      </Main>
    );
  } else {
    return <Navigate to="/" />;
  }
};

export default Parametres;
